"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CommandAddDistributionPlan = _interopRequireDefault(require("../model/CommandAddDistributionPlan"));
var _CommandEditDistributionPlan = _interopRequireDefault(require("../model/CommandEditDistributionPlan"));
var _DistributionPlan = _interopRequireDefault(require("../model/DistributionPlan"));
var _DistributionPlanQuery = _interopRequireDefault(require("../model/DistributionPlanQuery"));
var _DistributionPlanQueryResult = _interopRequireDefault(require("../model/DistributionPlanQueryResult"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* DistributionPlans service.
* @module api/DistributionPlansApi
* @version 1.1.3-alpha.1
*/
class DistributionPlansApi {
  /**
  * Constructs a new DistributionPlansApi. 
  * @alias module:api/DistributionPlansApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Create a new distribution plan
   * Creates a new distribution plan and returns the created object. If the distribution plan already exists, it returns the existing distribution plan
   * @param {Object} opts Optional parameters
   * @param {module:model/CommandAddDistributionPlan} opts.CommandAddDistributionPlan 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DistributionPlan} and HTTP response
   */
  createWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['CommandAddDistributionPlan'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _DistributionPlan.default;
    return this.apiClient.callApi('/api/v1/DistributionPlans', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Create a new distribution plan
   * Creates a new distribution plan and returns the created object. If the distribution plan already exists, it returns the existing distribution plan
   * @param {Object} opts Optional parameters
   * @param {module:model/CommandAddDistributionPlan} opts.CommandAddDistributionPlan 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DistributionPlan}
   */
  create(opts) {
    return this.createWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Get distribution plan
   * Returns the requested distribution plan
   * @param {String} id Id of the distribution plan to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DistributionPlan} and HTTP response
   */
  getWithHttpInfo(id) {
    let postBody = null;
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling get");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _DistributionPlan.default;
    return this.apiClient.callApi('/api/v1/DistributionPlans/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get distribution plan
   * Returns the requested distribution plan
   * @param {String} id Id of the distribution plan to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DistributionPlan}
   */
  get(id) {
    return this.getWithHttpInfo(id).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Get multiple distribution plans
   * Returns an array of requested distribution plans
   * @param {Object} opts Optional parameters
   * @param {Array.<String>} opts.request_body Ids of the distribution plans to get. Not specifiying ids will return all distribution plans
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DistributionPlan>} and HTTP response
   */
  getManyWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['request_body'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = [_DistributionPlan.default];
    return this.apiClient.callApi('/api/v1/DistributionPlans/getMany', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get multiple distribution plans
   * Returns an array of requested distribution plans
   * @param {Object} opts Optional parameters
   * @param {Array.<String>} opts.request_body Ids of the distribution plans to get. Not specifiying ids will return all distribution plans
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DistributionPlan>}
   */
  getMany(opts) {
    return this.getManyWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Query distribution plans
   * Queries distribution plans and returns a filtered, sorted and paged result
   * @param {Object} opts Optional parameters
   * @param {module:model/DistributionPlanQuery} opts.DistributionPlanQuery 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DistributionPlanQueryResult} and HTTP response
   */
  queryWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['DistributionPlanQuery'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _DistributionPlanQueryResult.default;
    return this.apiClient.callApi('/api/v1/DistributionPlans/query', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Query distribution plans
   * Queries distribution plans and returns a filtered, sorted and paged result
   * @param {Object} opts Optional parameters
   * @param {module:model/DistributionPlanQuery} opts.DistributionPlanQuery 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DistributionPlanQueryResult}
   */
  query(opts) {
    return this.queryWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Update distribution plan
   * Updates a distribution plan and returns the updated object
   * @param {String} id Id of the distribution plan to update
   * @param {Object} opts Optional parameters
   * @param {module:model/CommandEditDistributionPlan} opts.CommandEditDistributionPlan 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DistributionPlan} and HTTP response
   */
  updateWithHttpInfo(id, opts) {
    opts = opts || {};
    let postBody = opts['CommandEditDistributionPlan'];
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling update");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _DistributionPlan.default;
    return this.apiClient.callApi('/api/v1/DistributionPlans/{id}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Update distribution plan
   * Updates a distribution plan and returns the updated object
   * @param {String} id Id of the distribution plan to update
   * @param {Object} opts Optional parameters
   * @param {module:model/CommandEditDistributionPlan} opts.CommandEditDistributionPlan 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DistributionPlan}
   */
  update(id, opts) {
    return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }
}
exports.default = DistributionPlansApi;